import { computed } from 'vue'
import { useStore } from 'vuex'

export default function useMention () {
  const store = useStore()
  const regexp = /@([^\s]+)/g
  const userMap = computed(() => store.state.userMap)

  function getUserIds (text, mentionedIds) {
    const mentionedNameSet = new Set()
    let arr
    while ((arr = regexp.exec(text)) !== null) {
      mentionedNameSet.add(arr[1])
    }

    // console.log(mentionedNameSet)

    // 如果提及的用户 id 对应的昵称或名字在文本中出现，则返回，反之忽略掉
    return mentionedIds.filter(mentionedId => {
      const user = userMap.value[mentionedId]
      return user && (mentionedNameSet.has(user.nickname) || mentionedNameSet.has(user.name))
    })
    // return [...new Set(mentionedIds)]
  }

  function getFormattedUserIds (text, mentionedIds) {
    return [[6, 0, getUserIds(text, mentionedIds)]]
  }

  function getAddUserIds (origin, current) {
    return current.filter(item => !origin.includes(item))
  }

  function getRmUserIds (origin, current) {
    return origin.filter(item => !current.includes(item))
  }

  return {
    getUserIds,
    getFormattedUserIds,
    getAddUserIds,
    getRmUserIds
  }
}
